import React from 'react';

import { v4 as uuid } from 'uuid';

import AddControl from 'components/add_control/v2';
import Contact from 'bundles/apex/tasks/contacts/contact';
import Section from './section';

import type { Contact as ContactType, ContactsTask } from 'bundles/apex/tasks/types';

interface Props {
  contacts: ContactType[];
  contactsTasks: ContactsTask[];
  onChange: (conactsTask: ContactsTask[]) => void;
}

export default function Contacts({ contacts, contactsTasks, onChange }: Props) {
  contactsTasks = contactsTasks.filter(contactsTask => !contactsTask._destroy);
  contacts = contacts.filter((contact) => {
    return !contactsTasks.some(contactsTask => contactsTask.contact.id === contact.id);
  }) || [];

  function addContactsTask() {
    onChange([
      ...contactsTasks,
      { contact: contacts[0], localId: uuid() },
    ]);
  }

  function replaceContactsTask(replacement: ContactsTask) {
    onChange(contactsTasks.map((contactsTask) => {
      if (contactsTask.localId === replacement.localId) {
        contactsTask = replacement;
      }

      return contactsTask;
    }));
  }

  function deleteContactsTask(contactsTask: ContactsTask) {
    onChange(contactsTasks.map((existingContactsTask) => {
      if ((contactsTask.localId && contactsTask.localId === existingContactsTask.localId)
        || (contactsTask.id && contactsTask.id === existingContactsTask.id)) {
        existingContactsTask = { ...existingContactsTask, _destroy: true };
      }

      return existingContactsTask;
    }));
  }

  return (
    <React.Fragment>
      <Section label="Contacts" >
        {contacts.length > 0 &&
          <AddControl label="Add Contact" onClick={addContactsTask} />
        }
      </Section>

      {contactsTasks.map(contactsTask => (
        <Contact
          contacts={contacts}
          contactsTask={contactsTask}
          key={contactsTask.localId}
          onChange={replaceContactsTask}
          onDelete={deleteContactsTask}
        />
      ))}
    </React.Fragment>
  );
}
